import { Button, Flex, FlexProps, VStack } from '@chakra-ui/react'
import React from 'react'
import { useSelector } from 'react-redux'

import { IconSad } from '~shared-components/icons/brand/IconSad'
import { IconSomethingWrong } from '~shared-components/icons/brand/IconSomethingWrong'

import { H1, StandardText } from '../components'
import { RouterLink } from '../components/RouterLink/RouterLink'
import { useTranslations } from '../hooks/useTranslations'
import { LocationSelector } from '../redux/selectors/location.selector'
import { LayoutPadding } from '../theme'
import { isServer, setPageTitle } from '../utils'
import { Page } from '../utils/enums'

const cssLayoutWrapper = {
  '& > svg': {
    marginBottom: '20px',
  },
  '.typography-h1': {
    fontSize: '32px',
    marginBottom: '10px',
  },
  '.typography-text': {
    marginBottom: '22px',
  },
}

const LayoutWrapper: React.FC<FlexProps> = props => (
  <Flex
    alignItems="center"
    css={cssLayoutWrapper}
    flexDirection="column"
    h="100%"
    justifyContent="center"
    w="100%"
    {...props}
  />
)

const ButtonContainer: React.FC = props => <VStack spacing={5} {...props} />

const NotFound = () => {
  const t = useTranslations()
  const payload = useSelector(LocationSelector.payload)
  const documentNotFound = payload?.url === 'document-not-found'
  if (documentNotFound) setPageTitle('Something went wrong')

  const app = !isServer() && window.location.href.split('/')[4]

  const isClientUi = app === 'connect'

  const { label: fallbackLabel, page: fallbackPage } = isClientUi
    ? { label: t('label.browseproducts'), page: Page.Products }
    : { label: t('label.browseusers'), page: Page.Users }

  return (
    <LayoutPadding justify="center">
      {documentNotFound ? (
        <LayoutWrapper>
          <IconSad boxSize="100px" color="red.70" />
          <H1 bold>{t('something.wrong.documents')}</H1>
          <StandardText color="neutral.90">
            {t('message.documentnotfound')}
          </StandardText>
          <ButtonContainer>
            <Button onClick={() => window.history.back()} variant="action">
              {t('label.retry')}
            </Button>
          </ButtonContainer>
        </LayoutWrapper>
      ) : (
        <LayoutWrapper>
          <IconSomethingWrong color="red.70" height="99px" width="64px" />
          <H1 bold>{t('page.NotFound')}</H1>
          <StandardText color="neutral.90">
            {t('message.pagenotfound')}
          </StandardText>
          {app && (
            <ButtonContainer>
              <RouterLink to={{ type: fallbackPage }}>
                <Button variant="action">{fallbackLabel}</Button>
              </RouterLink>
            </ButtonContainer>
          )}
        </LayoutWrapper>
      )}
    </LayoutPadding>
  )
}

export default NotFound
